import type { AnswerOptionGroup } from "../shared/inquiry-flow";

export interface SiteConfig {
  companyName: string;
  chatAvatarUrl: string;
  questions?: Array<{ id: string; label: string; question: string; options: string[]; optionGroups?: AnswerOptionGroup[]; position: number; acquisitionFieldKey?: string | null }>;
  acquisitionFields?: Array<{ key: string; label: string; required: boolean; instruction: string; position: number }>;
}

const companyName = import.meta.env.VITE_COMPANY_NAME?.trim();
const chatAvatarUrl = import.meta.env.VITE_CHAT_AVATAR_URL?.trim();

export const defaultSiteConfig: SiteConfig = Object.freeze({
  companyName: companyName || "株式会社デモ",
  chatAvatarUrl: chatAvatarUrl || "",
});
